<template>
    <div class="ord-tab">
        <OrdersTableComponent ref="table" @order-cancelled="$emit('order-cancelled')" />
    </div>
</template>

<script>
import OrdersTableComponent from "./_orders-table.component.vue";

export default {
    name: "OrdersTab",
    components: { OrdersTableComponent },
    methods: {
        reload() {
            this.$refs.table.load(this.$refs.table.pagination.current);
        },
    },
};
</script>
